import { Box, CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{ loading: boolean; backgroundColor?: string }>;

export const ComponentLoader = ({ loading, children, backgroundColor = 'rgba(0,0,0,0.05)' }: Props) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        data-role="overlay-loader"
        sx={{
          color: 'primary-light',
          visibility: loading ? 'visible' : 'hidden',
          opacity: loading ? 1 : 0,
          position: 'absolute',
          inset: 0,
          backgroundColor,
          transition: 'all 0.3s ease-in-out',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1,
        }}
      >
        <CircularProgress color="inherit" aria-label={t('a11y.general.loading')} />
      </Box>
      <Box data-role={`overlay-loader-${loading ? 'active' : 'inactive'}`} sx={{ opacity: loading ? 0.3 : 1, transition: 'all 0.3s ease-in-out' }}>
        {children}
      </Box>
    </Box>
  );
};
